import { useState, type FormEvent } from 'react';
import {
  useToolCall, PlatformSelect, GenerateButton, CopyButton, LimitReached, ResultFunnel, ErrorNote,
  type ToolPlatform,
} from './aiToolShared';

type Idea = { hook: string; angle: string; sampleCaption: string };

export function IdeaGenerator() {
  const [niche, setNiche] = useState('');
  const [platform, setPlatform] = useState<ToolPlatform>('instagram');
  const { run, loading, error, limitReached, data } = useToolCall<{ ideas: Idea[] }>('/api/tools/ideas');

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (niche.trim().length < 2) return;
    run({ niche: niche.trim(), platform });
  }

  return (
    <div>
      <form onSubmit={onSubmit} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Tu nicho o sector</span>
          <input
            value={niche}
            onChange={(e) => setNiche(e.target.value)}
            maxLength={400}
            placeholder="Ej.: cafetería de especialidad en Madrid"
            className="mt-1 w-full rounded-xl border border-slate-300 px-3.5 py-3 text-slate-900 focus:border-brand-500 focus:ring-2 focus:ring-brand-200 outline-none"
          />
        </label>
        <PlatformSelect value={platform} onChange={setPlatform} />
        <GenerateButton loading={loading} label="Generar ideas" />
      </form>

      {error && <ErrorNote message={error} />}
      {limitReached && <div className="mt-6"><LimitReached /></div>}

      {data && data.ideas.length > 0 && !limitReached && (
        <ResultFunnel>
          <div className="grid gap-4 sm:grid-cols-2">
            {data.ideas.map((idea, i) => (
              <div key={i} className="rounded-xl border border-slate-200 bg-white p-4">
                <h3 className="font-semibold text-slate-900 leading-snug">{idea.hook}</h3>
                {idea.angle && <p className="mt-1.5 text-xs font-medium uppercase tracking-wide text-brand-600">{idea.angle}</p>}
                {idea.sampleCaption && (
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{idea.sampleCaption}</p>
                )}
                <div className="mt-3">
                  <CopyButton text={[idea.hook, idea.angle, idea.sampleCaption].filter(Boolean).join('\n')} />
                </div>
              </div>
            ))}
          </div>
        </ResultFunnel>
      )}
    </div>
  );
}
